// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__75Dm4","iconWithCounter":"styles_iconWithCounter__0IQZG","counterForLabel":"styles_counterForLabel__hl8di","counterForIcon":"styles_counterForIcon__sgR7M"};